// src/components/Hero.tsx - VERSION CORRIGÉE
import { useState, useEffect } from 'react';
import { Calendar, Phone, ChevronDown } from 'lucide-react';
import CalendarPopup from './CalendarPopup';
import logoAuroreRH from '../assets/logoaurorerh.png';

export default function Hero() {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
  const [hideScrollDown, setHideScrollDown] = useState(false);

  const scrollToNextSection = () => {
    const about = document.getElementById('about');
    const targetY = about
      ? about.getBoundingClientRect().top + window.pageYOffset - 80 + 40
      : window.innerHeight - 80;

    window.scrollTo({ top: targetY, behavior: 'smooth' });
  };

  useEffect(() => {
    const onScroll = () => setHideScrollDown(window.scrollY > 50);

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <section 
        className="min-h-screen flex items-center justify-center bg-aurore-pale dark:bg-warm-gray-900 overflow-hidden pt-32 md:pt-28 pb-32 relative w-full hero-section-pad"
        style={{ scrollMarginTop: '100px' }}
      >
        <div className="container mx-auto px-6 w-full">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
              {/* LOGO */}
              <div className="relative order-1 lg:order-2 flex justify-center lg:justify-start mt-0 hero-logo-adjust">
                <img
                  src={logoAuroreRH}
                  alt="Aurore RH"
                  width="866"
                  height="763"
                  fetchPriority="high"
                  className="w-full max-w-sm lg:max-w-full h-auto object-contain opacity-95"
                />
              </div>

              {/* TEXTE */}
              <div className="space-y-6 md:space-y-7 lg:space-y-9 order-2 lg:order-1">
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-warm-gray-900 dark:text-warm-gray-100 leading-tight text-center lg:text-left">
                  Vous vivez un conflit au travail, un recrutement bloqué ou une situation RH complexe ?
                  <span className="block text-aurore-dark mt-3 font-normal text-2xl md:text-3xl lg:text-3xl">
                    Vous n'êtes pas seul·e face à cela
                  </span>
                </h1>

                <p className="text-lg md:text-xl text-warm-gray-700 dark:text-warm-gray-300 leading-relaxed-plus text-center lg:text-left">
                  Tensions avec un collaborateur, règlement intérieur à rédiger, bulletin de paie incompréhensible…
                  Je vous aide à y voir clair et à agir sereinement, sans jugement ni jargon.
                </p>

                <div className="hidden lg:flex flex-col gap-4 max-w-md mx-auto lg:mx-0">
                  <button
                    onClick={() => setIsCalendlyOpen(true)}
                    className="flex items-center justify-center space-x-2 bg-aurore-dark text-white px-8 py-4 rounded-2xl hover:bg-aurore-medium hover:shadow-lg transition-all duration-500 font-medium shadow-sm text-base whitespace-nowrap"
                  >
                    <Calendar className="w-5 h-5" />
                    <span>Parler de ma situation (gratuit 30 min)</span>
                  </button>

                  <a
                    href="tel:+33750717728"
                    className="flex items-center justify-center space-x-2 bg-white dark:bg-warm-gray-800 text-aurore-dark px-8 py-4 rounded-2xl border-2 border-aurore-light dark:border-warm-gray-600 hover:border-aurore-medium hover:bg-aurore-pale dark:hover:bg-warm-gray-700 transition-all duration-500 font-medium text-base whitespace-nowrap"
                  >
                    <Phone className="w-5 h-5" />
                    <span>07 50 71 77 28</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* BOUTON SCROLL */}
        <button
          onClick={scrollToNextSection}
          aria-label="Scroll vers la section suivante"
          data-keep-animation="true"
          className={`
            fixed bottom-8 left-1/2 -translate-x-1/2
            flex w-14 h-14 items-center justify-center
            rounded-full
            bg-aurore-light/60 dark:bg-warm-gray-800/80 backdrop-blur-sm
            text-aurore-dark dark:text-warm-gray-200
            hover:bg-aurore-medium hover:text-white
            shadow-md hover:shadow-lg
            transition-all duration-500 ease-out
            animate-bounce-slow
            focus:outline-none focus:ring-2 focus:ring-aurore-medium/40 focus:ring-offset-2
            cursor-pointer group z-40
            ${hideScrollDown ? 'opacity-0 pointer-events-none' : 'opacity-100'}
          `}
        >
          <ChevronDown className="w-6 h-6 transition-transform duration-500 group-hover:translate-y-1" />
        </button>
      </section>

      <CalendarPopup
        isOpen={isCalendlyOpen}
        onClose={() => setIsCalendlyOpen(false)}
      />
    </>
  );
}